import { useQuery } from '@tanstack/react-query'
import { account } from './api'

// The single source of truth for "am I logged in": GET /api/me returns 401 when there is
// no valid session, which the query treats as "not logged in" rather than an error to
// retry — a session that doesn't exist yet is the normal starting state, not a failure.
export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: account.me,
    retry: false,
    staleTime: 30_000,
  })
}
